import { useContext, useMemo } from 'react';
import { ProgressBar } from '@library/components/progress/ProgressBar';
import { ResolutionDetailsContext } from '@bo-hooks/resolutions/resolutionDetails';
import { formatDate } from '@library/component-utils/dateTime';

export const ResolutionDetailsProcess = () => {
  const { resolutionDetails } = useContext(ResolutionDetailsContext);

  const { actualAffectedWagers, estimatedAffectedWagers, processingStartedAt } =
    resolutionDetails;

  const percentageValue = useMemo(() => {
    if (estimatedAffectedWagers === 0) {
      return 0;
    }
    return Math.round((actualAffectedWagers / estimatedAffectedWagers) * 100);
  }, [actualAffectedWagers, estimatedAffectedWagers]);

  const formattedStartedAtTime = formatDate({
    date: processingStartedAt,
    pattern: 'hh:mm a'
  });

  return (
    <div className="flex grow flex-col items-center justify-center gap-6">
      <div className="flex w-[500px] flex-col items-start gap-1">
        <p className="text-soClean-100 text-base font-semibold">
          Processing refund
        </p>
        <p className="text-soClean-180 text-sm font-medium">
          Please wait, your mass refund is in progress.
        </p>
      </div>
      <div>
        <div className="flex w-[500px] items-center gap-2 self-stretch">
          <ProgressBar
            className="w-[500px]"
            value={percentageValue}
            progressBarColor="bg-stankonia-100"
          />
          <p className="text-soClean-100 text-sm">{percentageValue}%</p>
        </div>
        <div className="flex justify-between gap-1 self-stretch">
          <p className="text-soClean-180 text-xs">
            {`${actualAffectedWagers} processed out of ${estimatedAffectedWagers}`}
          </p>
          <p className="text-soClean-180 text-xs">
            Started at: {formattedStartedAtTime}
          </p>
        </div>
      </div>
    </div>
  );
};
